import isEmpty from 'lodash/isEmpty'

const cmp = isMin => (a, b) => {
  if (a === b) {
    return 0
  }

  const r = a > b ? 1 : -1

  return isMin ? r : -1 * r
}

export default function(frames, isMin = true) {
  if (isEmpty(frames)) {
    return [0, 0]
  }

  const onlyWidth = frames.map(frame => frame.width).sort(cmp(isMin))
  const onlyHeight = frames.map(frame => frame.height).sort(cmp(isMin))

  return [onlyWidth.shift(), onlyHeight.shift()]
}



// WEBPACK FOOTER //
// ./src/utils/findMaxOrMinFrame.js